import { NewLink } from "@/components/new-link";

import { PageTitle } from "@/contexts/page-title";
import NoAuthDeprecated from "@/components/no-auth/no-auth-deprecated";
import NoAuth from "@/components/no-auth/no-auth";
import { useFlags } from "launchdarkly-react-client-sdk";
import { FeatureFlag } from "@/constants";

const UnauthorisedPage = () => {
    const flags = useFlags();
    return (
        <>
            <PageTitle title={"Unauthorised"} />
            {flags[FeatureFlag.IL_4194_POWER_MOVE] ? (
                <NoAuth
                    title2={"You do not have permission to access this page."}
                    redirectIfAuthenticated={false}
                ></NoAuth>
            ) : (
                <NoAuthDeprecated
                    message={"You do not have permission to access this page."}
                    redirectIfAuthenticated={false}
                >
                    Try {<NewLink to={{ pathname: "/" }}>Home</NewLink>}?
                </NoAuthDeprecated>
            )}
        </>
    );
};

export default UnauthorisedPage;
